export const ROLE_TERM_MANAGER = "ROLE_TERM_MANAGER";
export const ROLE_ANALYST = "ROLE_ANALYST";
export const ROLE_ADMIN = "ROLE_ADMIN";

export default [ROLE_ADMIN, ROLE_ANALYST, ROLE_TERM_MANAGER];
